var map = {
	"./4Hubris1Player.jpg": 197,
	"./Marcus+Bystander.jpg": 198,
	"./Marcus+Girl.jpg": 199,
	"./MarcusHelping.jpg": 200,
	"./MarcusRodrigoPlayerBoy.jpg": 201,
	"./StrangerDanger.jpg": 202
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;



//////////////////
// WEBPACK FOOTER
// ./src/images/forskar-fredag ^\.\/.*$
// module id = 215
// module chunks = 0